<div class="kabas-login">
  <div *ngIf="qrScannerVisible">
    <div class="max-w-xl m-i-auto relative">
      <campus-camera
        [showOverlay]="true"
        [isScannerEnabled]="true"
        [showCameraSelect]="true"
        (scanResultReceived)="onScanResultReceived($event)"
        data-cy="qr-scanner"
      ></campus-camera>
      <div
        *ngIf="scanError$ | async as scanError"
        class="[ absolute index-overlay error-container p-i-s p-b-2xs corner-s border border-error bottom-0 left-0 right-0 center-content ]"
        data-cy="qr-scanner-error"
      >
        {{ scanError }}
      </div>
    </div>
  </div>
  <div class="[ flex items-center justify-center ]">
    <kabas-login-student
      *ngIf="role === 'student'"
      [success]="success"
      [error]="error"
      [qrScannerVisible]="qrScannerVisible"
      [classGroups]="classGroups$ | async"
      (schoolCode)="schoolCodeSet($event)"
      (submitForm)="login($event)"
      (ssoLoginClicked)="ssoLogin($event)"
      (afterSuccess)="goToPlatform()"
      (forgetPerson)="forgetPerson($event)"
      (showQrScanner)="showQrScanner($event)"
      [persistedUsers]="persistedUsers$ | async"
      data-cy="modal-login-student"
    ></kabas-login-student>

    <kabas-login-teacher
      *ngIf="role === 'teacher' || role === 'schooladmin'"
      (submitForm)="login($event)"
      [success]="success"
      (afterSuccess)="goToPlatform()"
      (forgotPassword)="resetPassword($event)"
      [role]="role"
      data-cy="modal-login-teacher"
    ></kabas-login-teacher>
  </div>
</div>
